import React, { useEffect, useState } from "react";
import {StyledPaymentSection} from "./PaymentSection.style";
import {PricingStyles} from "../PricingList/PricingSection/PricingSection.style";
import {FiCheckSquare} from "react-icons/fi";
import bgCard from "../../../assets/bg-card2.png";
import Button from "components/molecules/Button";
import {RiArrowLeftSLine} from "react-icons/ri";
import {useNavigate} from "react-router-dom";
import {useAuthContext} from "Context/authContext";
import {CardElement, PaymentElement, useElements, useStripe} from "@stripe/react-stripe-js";
import userService from "services/userService";

const PaymentSection = () => {
  const stripe = useStripe();
  const elements = useElements();
  const navigate = useNavigate();
  const { refetch, user } = useAuthContext();

  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [plans, setPlans] = useState({ monthlyPlan: [], yearlyPlan: [] });

  useEffect(() => {
    const fetchPlans = async () => {
      try {
        const data = await userService.getPlans();
        setPlans(data);
      } catch (err) {
        console.error("Error fetching plans:", err.message);
      }
    };
    fetchPlans();
  }, []);

  const handleSubmit = async (e) => {
    if (!stripe || !elements) return;

    setLoading(true);

    const { error } = await stripe.confirmPayment({
      elements,
      confirmParams: {
        return_url: window.location.origin + "/dashboard",
      },
    });

    if (error) {
      setErrorMessage(error.message);
    }

    setLoading(false);
  };

  return (
    <StyledPaymentSection>
      <div
        className="column"
        style={{
          backgroundImage: `url(${bgCard})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
        }}
      >
        <Button
          width="87px"
          className="btn"
          variant="white"
          gap="1px !important"
          onClick={() => navigate(-1)}
        >
          <RiArrowLeftSLine />
          Back
        </Button>

        <PricingStyles>
          <div className="pricing-holder">
            {plans.monthlyPlan.slice().reverse().map((plan, index) => (
              <div key={plan.id} className="col proPlan" data-aos="fade-up">
                <div className="header">
                  {index === 1 && <span className="tag">Most Popular</span>}
                  <strong className="title">{plan.product.name}</strong>
                  <div className="price-box">
                    <sup>From</sup>
                    <strong className="price">
                      ${plan.unit_amount / 100}
                    </strong>
                    <sub> / {plan.recurring.interval}</sub>
                  </div>
                  <div className="no-card">
                    <button className="btn" type="button">
                      Choose {plan.product.name}
                    </button>
                  </div>
                </div>
                <ul className="info-list">
                  {/* Placeholder features – replace with real plan metadata if needed */}
                  <li>
                    <FiCheckSquare size={16} color="rgba(148,148,148,1)" />
                    <span className="text">Menu management</span>
                  </li>
                  <li>
                    <FiCheckSquare size={16} color="rgba(148,148,148,1)" />
                    <span className="text">Analytics dashboard</span>
                  </li>
                </ul>
              </div>
            ))}
          </div>
        </PricingStyles>
      </div>

      <div className="column">
        <form onSubmit={handleSubmit} className="col-2">
          <h2 className="col-title">Payment Information</h2>
          <PaymentElement />
          <Button
            disabled={!stripe || loading}
            width="100%"
            variant="secondary"
            className="submit-btn"
          >
            {loading ? "Processing..." : "Subscribe"}
          </Button>
          {errorMessage && <p style={{ color: "red" }}>{errorMessage}</p>}
        </form>
      </div>
    </StyledPaymentSection>
  );
};

export default PaymentSection;
